import type { ReactNode } from 'react';
import { Header } from './Header';
import { PageBackground } from './PageBackground';

interface PublicLayoutProps {
  children: ReactNode;
}

export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <PageBackground>
      <Header />
      <main>{children}</main>
    </PageBackground>
  );
}
